__turbopack_context__.v({
  "addressInput": "AddressInput-module__ZIXBpq__addressInput",
  "addressInputContainer": "AddressInput-module__ZIXBpq__addressInputContainer",
});
